export const users = [
  {
    bgColor: "#3E8CF7",
    candidateName: "Yash Bhatt",
    imgPath: "blueImg",
    jobType: "Frond End Developer",
    key: 1,
    team: "Blue.OODA",
  },
  {
    bgColor: "#3E8CF7",
    candidateName: "Jaydeep Kotak",
    imgPath: "blueImg",
    jobType: "Graphic Designer",
    key: 2,
    team: "Blue.OODA",
  },
  {
    bgColor: "#8435F5",
    candidateName: "Hemang Gohel",
    imgPath: "purpleImg",
    jobType: "Internet Marketing Strategist",
    key: 3,
    team: "Purple.ODS",
  },
  {
    bgColor: "#FF261D",
    candidateName: "Parth Thakkar",
    imgPath: "redImg",
    jobType: "Product Manager",
    key: 4,
    team: "Red.RBAS",
  },
  {
    bgColor: "#DE2FB1",
    candidateName: "Kenil Ranpura",
    imgPath: "pinkImg",
    jobType: "Data Analyst Senior",
    key: 5,
    team: "Pink.GSOS",
  },
  {
    bgColor: "#DE2FB1",
    candidateName: "Bhavik Prajapati",
    imgPath: "pinkImg",
    jobType: "Principal UX Designer",
    key: 6,
    team: "Pink.GSOS",
  },
  {
    bgColor: "#FF261D",
    candidateName: "Krupa Jani",
    imgPath: "redImg",
    jobType: "Product Manager",
    key: 7,
    team: "Red.RBAS",
  },
  {
    bgColor: "#3E8CF7",
    candidateName: "Vrutika Pandya",
    imgPath: "blueImg",
    jobType: "Graphic Designer",
    key: 8,
    team: "Blue.OODA",
  },
  {
    bgColor: "#8435F5",
    candidateName: "Vaibhavi Pandya",
    imgPath: "purpleImg",
    jobType: "Internet Marketing Strategist",
    key: 9,
    team: "Purple.ODS",
  },
];
